import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { deleteData } from "../../utility/adminApi";

function DeleteNotification(notificationId) {
  let itemId = notificationId?.notificationId || notificationId;
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id) => deleteData(`notifications/delete/`, id),
    retry: 1,
    onSuccess: () => {
      // Automatically refetches the "cart" query, ensuring the data is correct
      queryClient.invalidateQueries("notifications");
    },
  });
  const handleDelete = (id) => {
    mutation.mutate(id);
  };
  return (
    <>
      <DeleteIcon
        className="text-red-600 cursor-pointer"
        onClick={() => handleDelete(itemId)}
      />
    </>
  );
}

export default DeleteNotification;
